(function ($) {
	"use_strict";

	function loadScrollProgress() {

		function getTotal() {

			var $hentry = $('.hentry');
			var hentryOffset = $hentry.offset();
			var hentryOffsetTop = hentryOffset.top;
			var windowHeight = $(window).outerHeight();

			var windowScrollPosition = $(window).scrollTop();
			var hentryHeight = $hentry.outerHeight();
			var bodyScrollHeight = $(document).height();
			var hentryOffsetBottom = bodyScrollHeight - hentryHeight - hentryOffsetTop;

			// Calculate scroll position based on space in between.
			// Take the entire page height, then subtract the offset before and after hentry to find the number in the middle.
			// Finally, subtract the window height as well so that the progress indicator hits 100% when the BOTTOM of hentry scrolls into view.
			// The hentryOffsetTop is subtracted from windowScrollPosition to ensure a negative total until the scroll reaches the hentry div.
			var total = ((windowScrollPosition - hentryOffsetTop) / (bodyScrollHeight - hentryOffsetTop - hentryOffsetBottom - windowHeight)) * 100;

			// Bottom bracket
			if (windowScrollPosition > hentryOffsetTop + hentryHeight) {
				total = 100;
			}

			return total;
		}

		$(window).scroll(function (e) {
			e.preventDefault();
			var total = getTotal();
			$(".progress-bar__inner").css("width", total + "%");
		});

		/* Get scroll position on on page load */
		$(window).on('hashchange', function (e) {
			e.preventDefault();
			var total = getTotal();
			$(".progress-bar__inner").css("width", total + "%");
		});
		$(window).trigger('hashchange');

	}

	$(document).ready(function () {
		if ($('body').hasClass('single-post')) {
			loadScrollProgress();
		}
	});

})(jQuery);